import { SubscriptionService } from '@abp/ng.core';
import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { eThemeMetronicComponents } from '../../enums/components';
import { LayoutStateService } from '../../services/layout-state.service';
import { LayoutService } from '../../services/layout.service';

@Component({
	selector: 'hedou-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.less'],
	providers: [SubscriptionService],
	encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements AfterViewInit, OnInit {

	isNavbarExpanded$ = this.layoutStateService.get$('isNavbarExpanded');
	isMenuExpanded$ = this.layoutStateService.get$('isMenuExpanded');
	smallScreen$ = this.layoutStateService.get$('smallScreen');
	isMenuPlacementTop$ = this.layoutStateService.get$('isMenuPlacementTop');

	logoComponentKey = eThemeMetronicComponents.Logo;
	navbarComponentKey = eThemeMetronicComponents.Navbar;
	navItemsComponentKey = eThemeMetronicComponents.NavItems;
	navbarMobileComponentKey = eThemeMetronicComponents.NavbarMobile;
	sidebarComponentKey = eThemeMetronicComponents.Sidebar;
	// breadcrumbComponentKey = 
	

	headerContainerCSSClasses: string;
	headerMenuSelfDisplay: boolean;
	headerMenuSelfStatic: boolean;
	asideSelfDisplay: boolean;
	headerLogo: string;
	headerSelfTheme: string;
	headerMenuCSSClasses: string;
	headerMenuHTMLAttributes: any = {};
	routerLoaderTimout: any;

	@Output()
	mouseMoveContainer = new EventEmitter<Array<ElementRef<HTMLElement>>>();

	@ViewChild('navbarBrand', { read: ElementRef })
	navbarBrandRef: ElementRef<any>;

	constructor(
		private layoutStateService: LayoutStateService,
		private layoutService: LayoutService) {

	}
	ngOnInit(): void {
		this.headerContainerCSSClasses = this.layoutService.getStringCSSClasses(
			'header_container'
		);
		this.headerMenuSelfDisplay = this.layoutService.getProp(
			'header.menu.self.display'
		);
		this.headerMenuSelfStatic = this.layoutService.getProp('header.menu.self.static');
		this.asideSelfDisplay = this.layoutService.getProp('aside.self.display');
		this.headerSelfTheme = this.layoutService.getProp('header.self.theme') || '';
		this.headerLogo = this.getLogoURL();
		this.headerMenuCSSClasses = this.layoutService.getStringCSSClasses('header_menu');
		this.headerMenuHTMLAttributes = this.layoutService.getHTMLAttributes(
			'header_menu'
		);
	}

	ngAfterViewInit(): void {
		this.mouseMoveContainer.next([this.navbarBrandRef]);

	}


	private getLogoURL(): string {
		let result = 'logo-light.png';

		if (this.headerSelfTheme && this.headerSelfTheme === 'light') {
			result = 'logo-dark.png';
		}

		if (this.headerSelfTheme && this.headerSelfTheme === 'dark') {
			result = 'logo-dark.png';
		}

		return `./assets/media/logos/${result}`;
	}

}
